import type { ReactNode } from 'react'

interface SlotStudioLayoutProps {
  toolbar: ReactNode
  left: ReactNode
  right: ReactNode
}

export function SlotStudioLayout({ toolbar, left, right }: SlotStudioLayoutProps) {
  return (
    <div className="flex flex-col">
      <div className="border-b border-neutral-200 dark:border-neutral-700 px-4 py-2.5 bg-neutral-50 dark:bg-neutral-800/50">
        {toolbar}
      </div>
      <div className="grid grid-cols-[58fr_42fr] min-h-0">
        <div className="border-r border-neutral-200 dark:border-neutral-700 p-5 overflow-y-auto max-h-[580px]">
          {left}
        </div>
        <div className="p-5 overflow-y-auto max-h-[580px]">
          {right}
        </div>
      </div>
    </div>
  )
}
